export default __webpack_public_path__ + "28bc1ec1a0a83c2c6b1cca9ee0f7f449.svg";